// extracted by mini-css-extract-plugin
var _1 = "EmailMissingVariablesModal-moduleaction__Zrlta";
var _2 = "EmailMissingVariablesModal-moduleactions__DPHh4 MoreActionsButton-moduleactions__lS2E2";
var _3 = "EmailMissingVariablesModal-modulecontent__l_hsk";
var _4 = "EmailMissingVariablesModal-moduledropdown__O91z9";
var _5 = "EmailMissingVariablesModal-modulefileName__gwzk0 Text-moduletext__Z2j5F";
export { _1 as "action", _2 as "actions", _3 as "content", _4 as "dropdown", _5 as "fileName" }
